module.exports = __webpack_public_path__ + "img/astral-txt_18.4384f88d.svg";